import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1F98A781-6023-4368-AC06-5A421D166FCC
 * name terrain
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/terrain.svg
 * tags
 * - Nature 
 */
export const TerrainIcon = createSvgIcon(<><path d="M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z" /></>, 'TerrainIcon');
export default TerrainIcon